<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お知らせ</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <loading-spinner v-if="loadDetail"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="submitForm" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>お知らせ日</label>
                </div>
                <div class="md-layout-item md-size-30 md-small-size-100">
                  <md-field :class="getValidationClass('information_date')"
                            class="md-field md-theme-default md-input md-date-time">
                    <datetime-picker :sending="sending"
                                     :required="true"
                                     :label="`お知らせ日`"
                                     v-model="form.information_date"></datetime-picker>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('information_date')">{{ getValidationResponseMessage('information_date') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.information_date.required">{{ errors.information_date.required }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>件名</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('subject')">
                    <label>件名</label>
                    <md-input v-model="form.subject" required :disabled="sending"/>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('subject')">{{ getValidationResponseMessage('subject') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.subject.required">{{ errors.subject.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.subject.maxLength">{{ errors.subject.maxLength }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>本文</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('body')">
                    <label>本文</label>
                    <md-textarea v-model="form.body" required :disabled="sending"></md-textarea>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('body')">{{ getValidationResponseMessage('body') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.body.required">{{ errors.body.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.body.maxLength">{{ errors.body.maxLength }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>掲載日時</label>
                </div>
                <div class="md-layout md-layout-item md-alignment-center-left md-small-size-100">
                  <md-field :class="getValidationClass('publication_date_begin')"
                            class="md-layout-item md-size-45 md-small-size-100" required>
                    <datetime-picker :max-datetime="getMaxDateTime()"
                                     :sending="sending"
                                     :format="`yyyy-MM-dd HH:mm`"
                                     v-model="form.publication_date_begin"></datetime-picker>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('publication_date_begin')">{{ getValidationResponseMessage('publication_date_begin') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.publication_date_begin.required">{{ errors.publication_date_begin.required }}</span>
                  </md-field>
                  <label class="md-alignment-center-left">〜</label>
                  <md-field :class="getValidationClass('publication_date_end')"
                            class="md-layout-item md-size-45 md-small-size-100" required>
                    <datetime-picker :min-datetime="getMinDateTime()"
                                     :sending="sending"
                                     :format="`yyyy-MM-dd HH:mm`"
                                     v-model="form.publication_date_end"></datetime-picker>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('publication_date_end')">{{ getValidationResponseMessage('publication_date_end') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.publication_date_end.required">{{ errors.publication_date_end.required }}</span>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="md-layout md-alignment-center-center">
              <md-button :disabled="sending" class="md-raised md-primary" type="submit">
                <md-icon>save</md-icon>
                <span>登録する</span>
              </md-button>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false" :disabled="sending">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
  import 'vue-datetime/dist/vue-datetime.css'
  import moment                                            from 'moment';
  import {validationMixin}                                 from 'vuelidate'
  import {maxLength, required,}                            from 'vuelidate/lib/validators'
  import {Datetime}                                        from 'vue-datetime'
  import {mapActions}                                      from 'vuex';
  import DatetimePicker                                    from "../../../components/DatetimePicker";
  import FlashMessage                                      from '../../../components/FlashMessage';
  import LoadingSpinner                                    from '../../../components/LoadingSpinner';
  import {apiClientWithManagerToken as apiClient, apiList} from '../../../modules/apiClient';
  import Common                                            from '../../../modules/common';
  import Validation                                        from '../../../modules/validation';
  import CommonMixin                                       from '../../../mixins/commonMixin';

  export default {
    name      : "BackendAdminNotificationNew",
    components: {
      Datetime,
      DatetimePicker,
      FlashMessage,
      LoadingSpinner,
    },
    mixins    : [CommonMixin, validationMixin],
    props     : {
      id: String
    },
    data      : () => ({
      loadDetail      : false,
      informationId   : null,
      errorMessages   : [],
      validateResponse: [],
      form            : {
        information_date      : null,
        subject               : null,
        body                  : null,
        publication_date_begin: moment().format(Common.momentConst.startDateTFormat),
        publication_date_end  : moment().format(Common.momentConst.endDateTFormat),
      },
      errors          : {
        information_date      : {
          required: Validation.errorMessage(Validation.rules.required, 'informationDate'),
        },
        subject               : {
          required : Validation.errorMessage(Validation.rules.required, 'subject'),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'subject', 255),
        },
        body                  : {
          required : Validation.errorMessage(Validation.rules.required, 'body'),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'subject', 65535),
        },
        publication_date_begin: {
          required: Validation.errorMessage(Validation.rules.required, 'publicationBegin'),
        },
        publication_date_end  : {
          required: Validation.errorMessage(Validation.rules.required, 'publicationEnd'),
        },
      },
    }),
    validations() {
      return {
        form: {
          information_date      : {
            required,
          },
          subject               : {
            required,
            maxLength: maxLength(255),
          },
          body                  : {
            required,
            maxLength: maxLength(65535),
          },
          publication_date_begin: {
            required,
          },
          publication_date_end  : {
            required,
          },
        },
      };
    },
    mounted   : function () {
      if (this.$props.id) {
        this.informationId = this.$props.id;
        this.getInformationDetail();
      } else {
        this.fetchDetail = true;
      }
    },
    methods   : {
      ...mapActions('adminNotifications', [
        'saveBack',
      ]),
      backToList() {
        this.saveBack(true);
        this.$router.replace({name: 'BackendAdminNotifications'}).then();
      },
      getMinDateTime() {
        return this.form.publication_date_begin;
      },
      getMaxDateTime() {
        return this.form.publication_date_end;
      },
      errorNotFound() {
        if (this.$props.id) {
          if (!this.informationId) {
            this.errorMessages = [Common.messages.informationEdit.notFound];
            return true;
          }
        }
        return false;
      },
      getValidationResponseClass(fieldName) {
        for (let index in this.validateResponse) {
          if (this.validateResponse[index]['target'] === fieldName) {
            return true
          }
        }
        return false
      },
      getValidationInputClass(fieldName) {
        let fieldKeys = fieldName.split(".")
        let field;
        if (fieldKeys.length === 2) {
          field = this.$v.form[fieldKeys[0]][fieldKeys[1]];
        } else {
          field = this.$v.form[fieldName];
        }
        if (field) {
          return field.$invalid && field.$dirty
        }

        return false
      },
      getValidationClass(fieldName) {
        return {
          'md-invalid': this.getValidationInputClass(fieldName) || this.getValidationResponseClass(fieldName)
        }
      },
      getValidationResponseMessage(fieldName) {
        for (let index in this.validateResponse) {
          if (this.validateResponse[index]['target'] === fieldName) {
            return this.validateResponse[index]['message'];
          }
        }
        return null;
      },
      initForm() {
        this.form = {
          information_date      : null,
          subject               : null,
          body                  : null,
          publication_date_begin: moment().format(Common.momentConst.startDateTFormat),
          publication_date_end  : moment().format(Common.momentConst.endDateTFormat),
        };
      },
      createFormData() {
        return {
          information_date      : moment(this.form.information_date).format(Common.momentConst.startDateFormat),
          subject               : this.form.subject,
          body                  : this.form.body,
          publication_date_begin: moment(this.form.publication_date_begin).format(Common.momentConst.dateTimeFormat),
          publication_date_end  : moment(this.form.publication_date_end).format(Common.momentConst.dateTimeFormat),
        };
      },
      parseInformationDetail($informationDetail) {
        this.form = {
          information_date      : moment($informationDetail.information_date).format(Common.momentConst.dateFormat),
          subject               : $informationDetail.subject,
          body                  : $informationDetail.body,
          publication_date_begin: moment($informationDetail.publication_date_begin).format(Common.momentConst.dateTimeTFormat),
          publication_date_end  : moment($informationDetail.publication_date_end).format(Common.momentConst.dateTimeTFormat),
        };
      },
      getInformationDetail() {
        this.successMessage = null;
        this.sending        = true;
        this.loadDetail     = true;
        const detailUrl     = apiList.information.detail.replace(':information_id', this.informationId);
        apiClient.get(detailUrl)
          .then(response => {
            const result = response.data;
            if (result.errors) {
              this.informationId = null;
              this.errorMessages = result.errors;
              return;
            }
            this.parseInformationDetail(result.information);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending     = false;
            this.loadDetail  = false;
            this.fetchDetail = true;
          });
      },
      updateInformation() {
        this.sending          = true;
        this.validateResponse = [];
        const url             = apiList.information.update.replace(':information_id', this.informationId);
        apiClient.put(url, this.createFormData())
          .then(response => {
            const result = response.data;
            if (result.errors) {
              for (let index in result.errors) {
                if (!result.errors[index]['target']) {
                  this.errorMessages = result.errors;
                  break;
                }
                this.validateResponse = result.errors
              }
              return;
            }

            if (this.informationId) {
              this.setSnackBar(Common.messages.informationEdit.updateSuccess);
              this.backToList();
            } else {
              this.errorMessages = [Common.messages.informationEdit.updateError];
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      registerInformation() {
        this.sending          = true;
        this.validateResponse = [];
        apiClient.post(apiList.information.registry, this.createFormData())
          .then(response => {
            const result = response.data;
            if (result.errors) {
              for (let index in result.errors) {
                if (!result.errors[index]['target']) {
                  this.errorMessages = result.errors;
                  break;
                }
                this.validateResponse = result.errors
              }
              return;
            }

            this.informationId = null;
            this.setSnackBar(Common.messages.informationEdit.registrySuccess);
            this.backToList();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      submitForm() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          if (this.$props.id) {
            this.updateInformation();
          } else {
            this.registerInformation();
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
